export const meta = {
  id: 'boruvka',
  name: 'Borůvka\'s Algorithm',
  category: 'Graph',
  complexity: {
    time: 'O(E log V)',
    space: 'O(V + E)'
  },
  description: 'Borůvka\'s algorithm finds a Minimum Spanning Tree by repeatedly selecting the cheapest edge from each component until only one component remains.'
};
